<template>
  <router-view v-if="ready" />
</template>

<script>
export default {
  data() {
    return {
      ready: false,
    };
  },
  created: function () {
    if (window.location.host === "server.varsanpr.com") {
      window.location.href = "https://portal.varsanpr.com";
      return;
    }

    this.$store
      .dispatch("auth/checkToken")
      .then(() => {
        this.ready = true;
      })
      .catch((err) => {
        console.error("Token check failed:", err);
        this.$store.dispatch("auth/logout");
        window.location.href =
          "https://gateway.varsanpr.com/login?redirect=" +
          window.location.origin +
          "/login";
      });
  },
  methods: {
    // historyBack(event) {
    //   if(event.keyCode === 32) {
    //     this.$router.go(-1);
    //   }
    // }
  },
};
</script>
